import { Editor } from '@tiptap/core';

import { ChatEmptyOutline, ListOutline, OrderedListOutline, PhotographOutline, TargetOutline } from '@bonusly/design-system';

import { SlashCommandOption } from './types';

export const createCommands = ({ onUploadFile }: { onUploadFile: (file: File) => Promise<string> }): SlashCommandOption[] => [
	{
		name: 'topic',
		label: 'Topic',
		icon: <ChatEmptyOutline />,
		action: (editor: Editor) => {
			editor.chain().focus().deleteCurrentNode().run();
			const { view } = editor;
			const editorElement = view.dom as HTMLElement;
			const topicId = editorElement.closest('[data-topic-id]')?.getAttribute('data-topic-id');
			window.dispatchEvent(new CustomEvent('create-topic', { detail: { topicId } }));
		},
	},
	{
		name: 'goal',
		label: 'Goal',
		icon: <TargetOutline />,
		action: (editor: Editor) => {
			editor.chain().focus().deleteCurrentNode().run();
			const { view } = editor;
			const editorElement = view.dom as HTMLElement;
			const topicId = editorElement.closest('[data-topic-id]')?.getAttribute('data-topic-id');
			window.dispatchEvent(new CustomEvent('create-goal', { detail: { topicId } }));
		},
	},
	{
		name: 'divider',
		action: () => {},
	},
	{
		name: 'bullet list',
		key: 'bullet_list',
		icon: <ListOutline />,
		action: (editor: Editor) => editor.chain().focus().toggleBulletList().run(),
	},
	{
		name: 'number list',
		key: 'ordered_list',
		icon: <OrderedListOutline />,
		action: (editor: Editor) => editor.chain().focus().toggleOrderedList().run(),
	},
	{
		name: 'image',
		key: 'image',
		icon: <PhotographOutline />,
		action: (editor: Editor) => {
			const el = document.createElement('input');
			const to = editor.state.selection.to;

			el.setAttribute('type', 'file');
			el.setAttribute('data-testid', 'use-file-upload-input');
			el.setAttribute('accept', ['jpg', 'jpeg', 'png', 'gif'].map((ext) => `.${ext}`).join(','));
			el.style.display = 'none';

			let file: File | undefined;

			const removeInputEl = () => {
				if (!file) {
					el.remove();
				}

				window.removeEventListener('focus', removeInputEl);
			};

			window.addEventListener('focus', removeInputEl);

			el.addEventListener('change', (e: Event) => {
				file = (e.target as HTMLInputElement).files?.[0];
				if (file) {
					onUploadFile(file).then((url) => {
						editor.commands.insertContentAt(to, [
							{
								type: 'image',
								attrs: {
									src: url,
								},
							},
							{
								type: 'paragraph',
							},
						]);
					});
				}
				el.remove();
			});

			el.click();
		},
	},
];
